import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import ModalCloseIcon from "../../common/Components/Icons/ModalCloseIcon";
import AddOrEditSubCategoryForm from "./AddOrEditSubCategoryForm";
const SubCategoryModal = (props: any) => {
  const { openModal, closeModal, editData, getAllData, handleName, form } =
    props;
  return (
    <Modal
      isOpen={openModal}
      toggle={closeModal}
      size="lg"
      fade={false}
      className="SubCategoryModal"
    >
      <ModalHeader>
        <div className="Heading">
          <h3>
            {editData?._id ? "Edit Sub-Category" : "Add New Sub-Category"}
          </h3>
          <ModalCloseIcon {...props} closeModal={closeModal} />
        </div>
      </ModalHeader>
      <ModalBody>
        <AddOrEditSubCategoryForm
          {...props}
          closeModal={closeModal}
          editData={editData}
          getAllData={getAllData}
          handleName={handleName}
          form={form}
        />
      </ModalBody>
    </Modal>
  );
};

export default SubCategoryModal;
